import { PromoCodeApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const promoCodeApi = new PromoCodeApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
